import React from 'react'

export const ContentSection = props => (
    <section className="content">{props.children}</section>
)